import { defineComponent as _defineComponent } from 'vue'

const __default__ = {
  name: 'TLinkButton',
};

import { Size, Variant } from '../design-system';
import { useButton } from '~/composables/components/useButton';

// NOTE: Must be a superset of TButtonProps
interface TLinkButtonProps {
  size?: Size;
  variant?: Variant;
  disabled?: boolean;
  isSubmitting?: boolean;
  icon?: string;
  to?: string;
  href?: string;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    size: { default: 'default' },
    variant: { default: 'default' },
    disabled: { type: Boolean, default: false },
    isSubmitting: { type: Boolean, default: false },
    icon: { default: undefined },
    to: { default: undefined },
    href: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { size: Size, variant: Variant, disabled: boolean, isSubmitting: boolean, icon: string, to: string, href: string };



const { classes, iconClasses } = useButton(props, 'link');

return { __sfc: true,props, classes, iconClasses }
}

})